import React from 'react';
import { IRNSummaryDetails } from '../../../common/types';
import { formatInvoices } from '../../utils/formatInvoices';

import {
    INVSummaryBox,INVSummaryItem,INVSummaryValue, CardLabel, CardLabelText
} from './styles';


interface INVSummaryCardProps {
    invSummaryCardData: IRNSummaryDetails;
  }

const InvSummary: React.FC<INVSummaryCardProps> = ({ invSummaryCardData })=>(
    <>
          {invSummaryCardData.totalNoOfInvoices!==0 && <INVSummaryBox>
             <INVSummaryItem>
                <INVSummaryValue>
                {formatInvoices( invSummaryCardData.totalNoOfInvoices,1)}
                </INVSummaryValue>
                <CardLabel  margin={5} padding={8} color="#E8E8E8" backgroundColor="#E8E8E8">
                        <CardLabelText color="#6D6D6D">TOTAL</CardLabelText>
                </CardLabel>
            </INVSummaryItem>

            <INVSummaryItem>
                <INVSummaryValue>
                {formatInvoices( invSummaryCardData.totalIrnGenerated,1)}
                </INVSummaryValue>
                <CardLabel  margin={5} padding={4} color="#DDFBE2" backgroundColor="#50CD65">
                        <CardLabelText color="#574900">GENERATED</CardLabelText>
                </CardLabel>
            </INVSummaryItem>

            <INVSummaryItem>
                <INVSummaryValue>
                {
                formatInvoices(invSummaryCardData.totalPendingIrnGeneration,1)
                }
                </INVSummaryValue>
                <CardLabel  margin={5} padding={4}color="#FFF7CE" backgroundColor="#EECE33">
                        <CardLabelText color="12422E">Not Generated</CardLabelText>
                </CardLabel>
            </INVSummaryItem>

            <INVSummaryItem>
                <INVSummaryValue>
                {formatInvoices(invSummaryCardData.totalIrnCancelled,1)}
                </INVSummaryValue>
                <CardLabel  margin={5} padding={4}color="#FFE5D4" backgroundColor="#FE9D54">
                        <CardLabelText color="#732A00">CANCELLED</CardLabelText>
                </CardLabel>
            </INVSummaryItem>

            <INVSummaryItem>
                <INVSummaryValue>
                {formatInvoices( invSummaryCardData.totalIrnFailed,1)}
                </INVSummaryValue>
                <CardLabel  margin={5} padding={4}color="#FFD7D5" backgroundColor="#FF685F">
                        <CardLabelText color="#732A00">FAILED</CardLabelText>
                </CardLabel>
            </INVSummaryItem>
        </INVSummaryBox>}
    </>
);

export default InvSummary;
